import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hf_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const formatPrice = (product, currency) => {
  if (currency === "USD") {
    return `$${Number(product.price_usd || 0).toFixed(2)}`;
  }
  const n = Number(product.price_idr || 0);
  return `Rp${n.toLocaleString("id-ID")}`;
};

export const formatMoney = (amountIdr, amountUsd, currency) => {
  if (currency === "USD") return `$${Number(amountUsd || 0).toFixed(2)}`;
  return `Rp${Number(amountIdr || 0).toLocaleString("id-ID")}`;
};

// Returns { price_idr, price_usd, tier } for a given quantity, applying the best matching wholesale tier
export const applyPriceTiers = (product, qty) => {
  const tiers = (product?.price_tiers || []).slice().sort((a, b) => b.min_qty - a.min_qty);
  const hit = tiers.find((t) => qty >= t.min_qty);
  if (hit) return { price_idr: hit.price_idr, price_usd: hit.price_usd, tier: hit };
  return { price_idr: product?.price_idr || 0, price_usd: product?.price_usd || 0, tier: null };
};

// Bundle mode: price_tiers rows are packages — { min_qty: pcs per pack, price_idr/price_usd: TOTAL pack price }
export const isBundleProduct = (product) => product?.pricing_mode === "bundle" && (product?.price_tiers || []).length > 0;

export const getBundleTier = (product, bundleQty) =>
  (product?.price_tiers || []).find((t) => Number(t.min_qty) === Number(bundleQty)) || null;

export const sortedBundles = (product) =>
  (product?.price_tiers || []).slice().sort((a, b) => a.min_qty - b.min_qty);

// All selectable options for a bundle product: 1 pc at base unit price + admin-defined packs
export const bundleOptions = (product) => [
  { min_qty: 1, price_idr: product?.price_idr || 0, price_usd: product?.price_usd || 0 },
  ...sortedBundles(product),
];

export const isVideoUrl = (url = "") => /\.(mp4|webm|mov|m4v)(\?.*)?$/i.test(url);
